<template>
  <div>
    <Nav></Nav>
    <PageHeader>
      <ZoneRole :need-toast="true" v-if="loginState.openid"></ZoneRole>
    </PageHeader>
    <div class="main">
      <div class="team_list_title">
        <div class="center">
          当前已有<span>超过200万</span>用户秒杀成功
        </div>
      </div>
      <div class="team_list_box border_box">
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>

        <div class="list" v-if="strangerTuan && strangerTuan.length">
          <div :key="'strangerItem' + index" v-for="(strangerItem, index) in strangerTuan">
            <StrangerItem :juonTuan="goToStrangerItem" :minJoinNum="minJoinTuanNum" :stranger="strangerItem"></StrangerItem>
          </div>
        </div>
        <!-- 陌生人团列表为空提示 -->
        <div class="list" v-else>
          <div class="item">
            <div class="user">
              <div class="user_img">
                <img alt src="../../../ui/LianPoH5/images/default_img.png" />
              </div>
              <div class="user_name" style="max-width: 3.5rem;">当前没有正在进行中的团</div>
            </div>
          </div>
        </div>
      </div>

      <div class="team_change_btn">
        <span class="btn" @click="refreshStrangerGroup">换一批</span>
      </div>
      <div class="team_return_btn" @click="goToIndex">回到活动首页</div>

      <Rule></Rule>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Nav from "./component/Nav.vue"
import StrangerItem from "./component/StrangerItem.vue"
import PageHeader from "./component/PageHeader.vue"
import ZoneRole from "./component/ZoneRole.vue"
import Rule from "./component/Rule.vue"
import tuanMixin from "./component/mixin.js"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "StrangerGroup",
  mixins: [tuanMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(true)
    })
  },
  data() {
    return {
      strangerTuan: "",

      canSubmit: true
    }
  },
  computed: {
    ...mapGetters(["loginState", "minJoinTuanNum", "tuanInfo", "accountType"])
  },
  methods: {
    ...mapActions([
      "getLoginState",
      "getGroupBuyings",
      "reportUserAction",
      "setLoadingStart",
      "setLoadingEnd",
      "closePageLoading",
      "setOnShareHandler"
    ]),
    init(firstTime) {
      this.getLoginState()
        .then(() => {
          this.closePageLoading()

          if (firstTime) {
            setTimeout(() => {
              this.setOnShareHandler()

              this.reportUserAction({
                iformat: configs.REPORT.PAGEVIEW.STRANGER_SHOW
              })
            }, 0)
          }

          this.setLoadingStart()
          this.canSubmit = false

          return this.getGroupBuyings()
        })
        .then(() => {
          this.setLoadingEnd()
          this.canSubmit = true

          let stranger = []
          if (this.tuanInfo && this.tuanInfo.buytuan && this.tuanInfo.buytuan.tuan && this.tuanInfo.buytuan.tuan.stranger_tuan) {
            let strangerInfo = this.tuanInfo.buytuan.tuan.stranger_tuan.split(";")

            if (strangerInfo) {
              strangerInfo.forEach(info => {
                let strangerInfoArray = info.split(",")
                // 区分QQ/WX的陌生人团
                if (
                  strangerInfoArray &&
                  ((strangerInfoArray[5] == "qq" && this.accountType == "qq") ||
                    (strangerInfoArray[5] == "wechat" && this.accountType == "wechat"))
                ) {
                  stranger.push(info.split(","))
                }
              })
            }

            // 控制最多展示10个陌生人团
            if (stranger.length > 10) stranger = stranger.slice(0, 10)

            this.strangerTuan = stranger
          }
        })
        .catch(error => {
          this.closePageLoading()

          this.setLoadingEnd()
          this.canSubmit = true

          this.catchInitError(error)
        })
    },
    goToStrangerItem(stranger) {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.STRANGER_JOIN,
        resultInfo: `tuan_id=${stranger[0]}`
      })
      this.$router.push(`/group-detail/${stranger[0]}`)
    },

    refreshStrangerGroup() {
      if (!this.canSubmit) return
      this.init()
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.REFRESH_STRANGER
      })
    },

    goToIndex() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BACK_TO_INDEX_FROM_STRANGER
      })
      this.$router.push("/?noOff=1")
    }
  },
  components: {
    PageHeader,
    ZoneRole,
    Rule,
    StrangerItem,
    Nav
  }
}
</script>

<style scoped>
</style>
